'use strict';

angular.module('PinMeTo.directives').directive('autofill', [
	'$timeout',
	function ($timeout) {
		let INTERVAL_MS = 500;
		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				let timer;
				function startTimer() {
					timer = $timeout(function () {
						let value = element.val();
						if (value && ngModel.$viewValue !== value) {
							ngModel.$setViewValue(value);
						}
						startTimer();
					}, INTERVAL_MS);
				}
				scope.$on('$destroy', function () {
					$timeout.cancel(timer);
				});

				startTimer();
			}
		};
	}
]);
